var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('HelloWorld')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }